import { useContext } from 'react';
import Filter from '../types/Filter';
import { FilterContext } from '../context/FilterContext';
import { Dropdown } from '../components/forms';

export default function FilterDropdown (props: { filterId: string, dropdownId: string, dataTip: string, applyFilter: Function })
{
	const { filterId, dataTip, applyFilter } = props;
	const { filters } = useContext (FilterContext);

	return (
		<span className="d-inline-block" data-tooltip-id="global-tooltip" data-tooltip-content={dataTip}>
			<Dropdown
				id={filterId}
				value={null}
				onChange={(value) => {
					const snapshot = filters.find ((item: Filter) => item.id === Number (value));
					if (snapshot) applyFilter (snapshot);
				}}
				options={filters.map ((item: Filter) => ({ value: item.id, label: item.name }))}
				placeholder={dataTip}
				filter
				filterPlaceholder="Search snapshots"
				ariaLabel={dataTip}
				icon="fal fa-filter fa-fw"
			/>
		</span>
	);
}
